import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { getCtaButtonSx } from './loginOverlay.styles';
import { DESKTOP_UP_MQ } from './loginOverlay.constants';
import type { LoginOverlayAction } from './loginOverlay.types';

type ActionItemProps = {
	action: LoginOverlayAction;
};

const ActionItem = ({ action }: ActionItemProps) => {
	const theme = useTheme();
	const descId = `${action.id}-description`;

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: '1fr',
				alignItems: 'center',
				justifyItems: 'center',
				rowGap: { xs: 4, sm: 4 },
				[DESKTOP_UP_MQ]: {
					gridTemplateColumns: '280px minmax(0, 1fr)',
					justifyItems: 'stretch',
					columnGap: 8,
					rowGap: 1.5
				}
			}}
		>
			<ButtonBase
				component={action.href ? 'a' : 'button'}
				href={action.href}
				type={action.href ? undefined : 'button'}
				onClick={action.onClick}
				aria-describedby={descId}
				sx={getCtaButtonSx(theme)}
			>
				{action.label}
			</ButtonBase>

			<Typography
				id={descId}
				variant="label"
				sx={{
					color: 'text.secondary',
					width: '100%',
					minWidth: 0,
					maxWidth: 440,
					textAlign: 'center',
					whiteSpace: 'normal',
					overflowWrap: 'anywhere',
					wordBreak: 'break-word',
					[DESKTOP_UP_MQ]: {
						width: '100%',
						maxWidth: 280,
						textAlign: 'left',
						whiteSpace: 'normal'
					}
				}}
			>
				{action.description}
			</Typography>
		</Box>
	);
};

export default ActionItem;
